import { render, staticRenderFns } from "./ContractExpiredSettingDialog.vue?vue&type=template&id=152526bc&scoped=true"
import script from "./ContractExpiredSettingDialog.vue?vue&type=script&lang=js"
export * from "./ContractExpiredSettingDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152526bc",
  null
  
)

export default component.exports